interface DeliverDate {
  numberOfDay: number
  targetStatus: TargetStatus
  dateExecution: DateExecution
  deliveryTime: string
}

interface TranslateObject {
  ja: string
  en: string
  ko: string
  zh: string
}

export const DeliveryMethod = {
  SMS: 'sms',
  Mail: 'mail',
} as const
export type DeliveryMethod = (typeof DeliveryMethod)[keyof typeof DeliveryMethod]

export interface MailDeliveryContentInput {
  title: string
  content: string
  contentEn: string
  rawContent: string
  rawContentEn: string
  status: MailDeliveryStatus
  lineNotificationStatus: LineNotificationStatus
  isNullSearchableChannelCode: boolean
  isSendToAfterDelivery: boolean
  stayTypeTarget: MailDeliveryStayTypeTarget
  deliveryDate: DeliverDate
  reservationStatuses: number[]
  channelCodes: string[]
}

export interface MailDeliveryContent {
  id: string
  title: TranslateObject
  content: TranslateObject
  rawContent: TranslateObject
  status: MailDeliveryStatus
  lineNotificationStatus: LineNotificationStatus
  isNullSearchableChannelCode: boolean
  isSendToAfterDelivery: boolean
  stayTypeTarget: MailDeliveryStayTypeTarget
  deliveryDate: DeliverDate
  reservationStatuses: number[]
  channelCodes: { reservationChannelCodeId: string; name: string }[]
  method: DeliveryMethod
}

export enum MailDeliveryStatus {
  Draft = 'draft',
  Reservation = 'reservation',
  Halt = 'halt',
}
export const mailDeliveryStatus = {
  [MailDeliveryStatus.Draft]: '下書き',
  [MailDeliveryStatus.Reservation]: '配信予定',
  [MailDeliveryStatus.Halt]: '配信停止',
}
export const isReservation = (status: string) => {
  return status === MailDeliveryStatus.Reservation
}
export const isDraft = (status: string) => {
  return status === MailDeliveryStatus.Draft
}

export enum TargetStatus {
  CheckIn = 'checkIn',
  Checkout = 'checkout',
}
export const targetStatus = [
  { value: TargetStatus.CheckIn, label: 'Check-in date' },
  { value: TargetStatus.Checkout, label: 'Check-out date' },
]

export enum DateExecution {
  Later = 'later',
  Ago = 'ago',
}
export const dateExecution = [
  { value: DateExecution.Later, label: DateExecution.Later },
  { value: DateExecution.Ago, label: DateExecution.Ago },
]

export enum LineNotificationStatus {
  All = 'all',
  Notified = 'notified',
  Unnoticed = 'unnoticed',
}
export const lineNotificationStatus = [
  { label: 'すべて', value: LineNotificationStatus.All },
  { label: '通知済み', value: LineNotificationStatus.Notified },
  { label: '未通知', value: LineNotificationStatus.Unnoticed },
]

export type MailDeliveryStayTypeTarget = 'all' | 'stay_only' | 'dayuse_only'

export const stayTypeTarget = [
  { label: '宿泊のみ送信', value: 'stay_only' },
  { label: 'デイユースのみ送信', value: 'dayuse_only' },
  { label: 'すべてに送信', value: 'all' },
] as const

export interface DeliveryContentItem {
  id: string
  title: TranslateObject
  status: string
  method: DeliveryMethod
  dateText: string
}

export interface TemplateContent {
  id: string
  title: TranslateObject
  name: string
  content: TranslateObject
}
